import React, { Component } from 'react'
import { Link, withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import classnames from 'classnames'

import {
  setUserSession,
  removeUserSession
} from '../actions/user-session'

class Login extends Component {
  constructor(props) {
    super(props)

    this.state = {
      email: '',
      password: '',
      isLoggingIn: false,
      error: null
    }

    this.activeUser = React.createRef()
    this.email = React.createRef()
    this.password = React.createRef()
  }

  componentWillMount() {
    const { email, userSession } = this.props

    // if (userSession.loggedIn === true && userSession.verification) this.props.removeUserSession()
    // if (userSession.verification && userSession.verification.email) this.setState({email: userSession.verification.email}) // TODO: Should still display it? Authorization will fetch user data twice if user was already signed in

    if (email) this.setState({email})
  }

  componentDidMount() {
    const { userSession } = this.props
    const { email } = this.state

    if (this.activeUser.current) {
      this.activeUser.current.focus()
    } else
    if (email) {
      this.password.current.focus()
    } else {
      this.email.current.focus()
    }
  }

  componentWillReceiveProps(nextProps) {
    const { userSession } = nextProps
    const { pathname } = nextProps.location

    if (userSession.isLoggingIn !== this.props.userSession.isLoggingIn) this.setState({isLoggingIn: userSession.isLoggingIn})
    if (userSession.loggedIn === true && this.props.userSession.loggedIn === false) {
      if (this.props.setModal) {
        this.props.setModal(false)

        this.props.history.replace({pathname})
      } else {
        this.props.history.replace({pathname: '/library'})
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { userSession } = this.props

    if (this.activeUser.current) this.activeUser.current.focus()
  }

  logIn = (e) => {
    e.preventDefault()

    const { email, password, isLoggingIn } = this.state

    if (!email || !password) {
      let credentials = 'credentials'
      credentials = !email ? 'email' : credentials
      credentials = !password ? 'password' : credentials
      credentials = !email && !password ? 'email and password' : credentials

      this.setState({error: `Please enter correct ${credentials}.`})
    } else
    if (isLoggingIn === false) {
      this.setState({error: null}, () => this.props.setUserSession(email, password))
    }
  }

  renderActiveUserButton() {
    const { userSession } = this.props

    return (
      <div style={{textAlign: 'center'}}>
        <input ref={this.activeUser}
          type="button"
          className="button button-continue button--primary"
          value={`Continue as ${userSession.user.email}`}
          onClick={() => this.props.history.replace({pathname: '/library'})} />
      </div>
    )
  }

  render() {
    const { modal, userSession } = this.props
    const { email, password, isLoggingIn, error } = this.state

    const className = classnames({
      'login': true,
      'login--modal': modal === true
    })

    const formClassName = classnames({
      'valid': email && password,
      'invalid': error
    })

    const buttonClassName = classnames({
      'button--disabled': isLoggingIn,
      'placeholder-loader': isLoggingIn,
      'placeholder-loader--success': isLoggingIn
    })

    return (
      <div className={className}>
        {
          modal !== true
          ? <h1 className="h1--default">Log in to Ridline</h1>
          : <h4>Log in to Ridline</h4>
        }

        {
          userSession.loggedIn && (userSession.user && userSession.user.email)
          ? this.renderActiveUserButton()
          : null
        }

        <form className={formClassName} onSubmit={this.logIn}>
          <ul className="ul--inline" data-error-msg={error}>
            <li data-title="Email">
              <input ref={this.email}
                type="text"
                className="input--light"
                value={email}
                onChange={(e) => this.setState({email: e.target.value})} />
            </li>

            <li data-title="Password">
              <input ref={this.password}
                type="password"
                className="input--light"
                value={password}
                onChange={(e) => this.setState({password: e.target.value})} />
            </li>
          </ul>

          <button className={buttonClassName} type="submit">Log in</button>
        </form>

        <Link to="/register">Or sign up alternatively</Link>
      </div>
    )
  }
}

Login.propTypes = {
  match: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  modal: PropTypes.bool,
  email: PropTypes.string,
  userSession: PropTypes.object,
  setUserSession: PropTypes.func,
  removeUserSession: PropTypes.func
}

Login.defaultProps = {
  match: {},
  location: {},
  history: {},
  modal: false,
  email: '',
  userSession: {},
  setUserSession: function() {},
  removeUserSession: function() {}
}

export const mapStateToProps = (state) => {
  return {
    userSession: state.userSession
  }
}

export const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    setUserSession,
    removeUserSession
  }, dispatch)
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Login))



// WEBPACK FOOTER //
// ./src/containers/login.js